import { SocialComponent } from '../Social/Social'
import {
    BrandLogoComponent, TitleComponent, SubtitleComponent
} from '../../uicomponents'
import FormStreetWaitlistComponent from '../FormStreetWaitlist/FormStreetWaitList'
import { ClientTypes } from '../../utilities/constants'
import styles from './StreetWaitList.module.scss'

const StreetWaitlistComponent = () => {
    return (
        <div className={styles.contentForm}>
            <BrandLogoComponent
                client={ClientTypes.STREET}
            />
            <SubtitleComponent>
                Sé el primero en enterarte.
            </SubtitleComponent>
            <TitleComponent>
                Sumate a nuestra waitlist. <br/> Algo rico te espera.
            </TitleComponent>
            <FormStreetWaitlistComponent />
            <SocialComponent />
        </div>
    )
}

export default StreetWaitlistComponent
